/**
 * Session token is base64(JSON.stringify({ id, username, role })) — see api/lib/auth.js.
 * Use when React auth state has not yet caught up to localStorage on first paint.
 */
export function parseUsernameFromToken(token: string | null): string | null {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token)) as { username?: unknown };
    const u = payload?.username;
    return typeof u === 'string' && u.length > 0 ? u : null;
  } catch {
    return null;
  }
}
